"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var eventemitter3_1 = tslib_1.__importDefault(require("eventemitter3"));
var lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
var lodash_set_1 = tslib_1.__importDefault(require("lodash.set"));
var d3_1 = require("d3");
var theme_1 = require("./theme");
var deep_merge_1 = require("./lib/deep-merge");
/**
 * TeaChart 全局上下文
 * 其中 options 只能通过 getOption 和 setOption 来进行读取
 *
 * @extends eventemitter3
 */
var Context = /** @class */ (function (_super) {
    tslib_1.__extends(Context, _super);
    /**
     * 初始化 Context
     * @param container 根元素
     * @param customTheme 主题配置
     */
    function Context(id, container, customTheme) {
        var _this = _super.call(this) || this;
        /**
         * Tea Chart 主题配置
         * @since 2.0
         */
        _this.theme = theme_1.Tea();
        /**
         * 配置项
         * @since 2.0
         */
        _this.options = {
            axis: {
                xAxis: {
                    enable: true,
                },
                yAxis: {
                    enable: true,
                },
            },
            legend: {
                enable: true,
                align: "bottom",
            },
            tooltip: {
                enable: true,
            },
            scale: {},
            connectNulls: {
                enable: true,
            },
            interaction: {},
        };
        _this.id = id;
        // 更新主题
        if (typeof customTheme === "object") {
            for (var key in customTheme) {
                if (Object.prototype.hasOwnProperty.call(customTheme, key)) {
                    _this.theme[key] = customTheme[key];
                }
            }
        }
        var _a = _this.theme, classPrefix = _a.classPrefix, backgroundColor = _a.backgroundColor;
        _this.container = container;
        _this.classPrefix = classPrefix;
        // 创建 SVG 根节点
        _this.root = d3_1.select(_this.container)
            .append("svg")
            .attr("class", classPrefix + "-chart-root")
            .attr("version", "1.1")
            .attr("xmlns", "http://www.w3.org/2000/svg")
            .attr("data-chart-id", id)
            .style("-webkit-user-select", "none")
            .style("-moz-user-select", "none")
            .style("-ms-user-select", "none")
            .style("user-select", "none");
        // 创建绘图区遮罩
        _this.plotMask = _this.root
            .append("defs")
            .append("clipPath")
            .attr("id", _this.id)
            .append("rect")
            .attr("x", 0)
            .attr("y", 0)
            .attr("fill", "none");
        // 创建背景
        _this.background = _this.root
            .append("rect")
            .attr("class", classPrefix + "-chart-background")
            .attr("fill", backgroundColor);
        // 创建绘图区背景
        _this.plotBackgound = _this.root
            .append("rect")
            .attr("class", classPrefix + "-chart-plot-background")
            .attr("fill", "none");
        return _this;
    }
    /**
     * 获取配置信息
     * @param optionKey 获取配置信息的 key
     * @param defaultValue 默认值
     * @returns 返回配置的值
     *
     * @since 2.0
     */
    Context.prototype.getOption = function (optionKey, defaultValue) {
        return lodash_get_1.default(this.options, optionKey, defaultValue);
    };
    /**
     * 设置配置信息
     * @param optionKey 待设置配置的 key
     * @param value 新的值
     *
     * @since 2.0
     */
    Context.prototype.setOption = function (optionKey, value) {
        var prev = this.getOption(optionKey);
        if (prev === undefined) {
            return lodash_set_1.default(this.options, optionKey, value);
        }
        return lodash_set_1.default(this.options, optionKey, deep_merge_1.deepMerge(prev, value));
    };
    /**
     * 设置主题配置
     * @param customTheme 用户自定义主题配置
     *
     * @since 2.0
     */
    Context.prototype.setTheme = function (customTheme) {
        deep_merge_1.deepMerge(this.theme, customTheme);
    };
    /**
     * 更新原始数据
     * @param dataSource 原始数据
     */
    Context.prototype.setDataSource = function (dataSource) {
        this.dataSource = dataSource;
    };
    /**
     * 获取图表宽度
     * @since 2.1.0
     */
    Context.prototype.getBackgroundWidth = function () {
        return parseInt(this.root.attr("width"), 10);
    };
    /**
     * 获取图表高度
     */
    Context.prototype.getBackgroundHeight = function () {
        return parseInt(this.root.attr("height"), 10);
    };
    /**
     * 获取绘图层宽度
     * @since 2.1.0
     */
    Context.prototype.getPlotWidth = function () {
        return parseInt(this.plotBackgound.attr("width"), 10);
    };
    /**
     * 获取绘图层高度
     */
    Context.prototype.getPlotHeight = function () {
        return parseInt(this.plotBackgound.attr("height"), 10);
    };
    return Context;
}(eventemitter3_1.default));
exports.Context = Context;
//# sourceMappingURL=context.js.map